// extracted by mini-css-extract-plugin
export default {"offline_user":"styles_offline_user__x3YyR"};